import styled, { css } from 'styled-components';
import { isGlobetrotter } from '../../utils/theming.js';
import mq from '../../utils/mediaQueries.js';

// @ts-nocheck
var sizes = {
  xxxs: 1.2,
  xxs: 1.2,
  xs: 1.6,
  s: 2.4,
  m: 3.2,
  l: 4.8,
  xl: 6.4
};
var Icon = styled.svg.withConfig({
  displayName: "Iconstyle__Icon",
  componentId: "sc-14paivs-0"
})(["display:inline-block;overflow:visible;", " ", " ", " ", ""], function (_ref) {
  var $size = _ref.$size;
  return $size && css(["height:", "rem;width:", "rem;"], sizes[$size], sizes[$size]);
}, function (_ref2) {
  var $sizeMobile = _ref2.$sizeMobile;
  return $sizeMobile && css(["", ""], mq.sMax(css(["height:", "rem;width:", "rem;"], sizes[$sizeMobile], sizes[$sizeMobile])));
}, function (_ref3) {
  var $strokeBasedIcon = _ref3.$strokeBasedIcon;
  return $strokeBasedIcon && css(["stroke-width:0.15rem;"]);
}, isGlobetrotter(css(["", " ", ""], function (_ref4) {
  var $size = _ref4.$size;
  return $size && css(["height:calc(", "rem + 0.2rem);width:calc(", "rem + 0.2rem);stroke-width:0.1rem;"], sizes[$size], sizes[$size]);
}, function (_ref5) {
  var $sizeMobile = _ref5.$sizeMobile;
  return $sizeMobile && css(["", ""], mq.sMax(css(["height:calc(", "rem + 0.2rem);width:calc(", "rem + 0.2rem);"], sizes[$sizeMobile], sizes[$sizeMobile])));
})));

export { Icon };
//# sourceMappingURL=Icon.style.js.map
